import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Route, CanLoad} from '@angular/router';
import {Injectable} from '@angular/core';
import {OktaService} from '../_services/okta.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate, CanLoad {

  constructor(
    private oktaService: OktaService,
  ) {}

  // CAN LOAD: FOR FEATURE MODULES SECURITY
  canLoad(route: Route) {
    return this.oktaService.getCachedAccessToken()
      .then((token) => {
        return !!token;
      });
  }

  // CAN ACTIVATE: FOR ROUTES SECURITY
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.oktaService.getCachedAccessToken()
      .then((token) => {
        return !!token;
      });
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }

}
